import { logout } from '@/api/user'
import { login, getInfo } from '@/api/users'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  userid: '',
  usernm: '',
  deptid: '',
  limittype: '',
  mobiletel: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token =encodeURIComponent(token) 
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERID: (state, userid) => {
    state.userid = userid
  },
  SET_USERNM: (state, usernm) => {
    state.usernm = usernm
  },
  SET_DEPTID: (state, deptid) => {
    state.deptid = deptid
  },
  SET_LIMITTYPE: (state, limittype) => {
    state.limittype = limittype
  },
  SET_MOBILETEL: (state, mobiletel) => {
    state.mobiletel = mobiletel
  }
}

const actions = {
  // user login
  login({  commit, state, dispatch  }, userInfo) {
    const { username, password } = userInfo
    return new Promise( (resolve, reject) => {
      //const data = { pageNO: '1', pageSize: '10', conQuery: JSON.stringify({ MOBILETEL: username.trim(), PWD: password }) }
      const data = { mobiletel:username,pwd:password}
      login(data).then(async response => {
        var userid = username;
        if (response.success =='0') {
          if(response.data && response.data.userinfo) {
            let info = response.data.userinfo;
            // commit('SET_TOKEN', userid);
            // localStorage.setItem('userName',encodeURIComponent(userid));
            //setToken(userid);
            if(info.sysadmin!='0'){
              reject('非管理员不能登录，请先设置为管理员！')
            }else{
              commit('SET_TOKEN', info.token);
              //localStorage.setItem('userName',encodeURIComponent(info.userid));
              localStorage.setItem('userid',encodeURIComponent(info.userid));
              localStorage.setItem('usertoken',info.token);
              setToken(info.token);// info.userid
              commit('SET_USERID', info.userid)// ALARMSOERCE :"0"  ENABLEDSTA:1

              //let uinfo = await dispatch('user/setUserInfo', info, { root: true })
              resolve(userid);
            }
          } else{
            reject('用户名或密码错误！')
          }
        } else {
          reject(response.message)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state , dispatch}) {
    return new Promise((resolve, reject) => {
     // const query = { pageNO:1,pageSize:10,userid: localStorage.getItem('userid') ,enabledsta:'0' }
     const query = { pageNO:1,pageSize:10, conQuery:{userid: localStorage.getItem('userid') ,enabledsta:'0'} }
      if(!query.conQuery.userid) {
        reject('获取用户信息失败，请重新登录！')
        return 
      }
      getInfo(query).then(async response => {
        if (response.success =='0') {
          const { data } = response
          if (!data || !data.datalist || !data.datalist.list|| !data.datalist.list.length) {
            reject('获取用户信息失败，请重新登录！')
          } else {
            const info = data.datalist.list[0]
            let uinfo = await dispatch('user/setUserInfo', info, { root: true })
            resolve(uinfo)
          }
        } else {
          reject(response.message)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  setUserInfo({ commit, state, dispatch },info) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', info.token);
      //localStorage.setItem('userName',encodeURIComponent(info.userid));
      localStorage.setItem('userid',encodeURIComponent(info.userid));
      localStorage.setItem('usertoken',info.token);
      setToken(info.token);// info.userid
      commit('SET_USERID', info.userid)// ALARMSOERCE :"0"  ENABLEDSTA:1
      commit('SET_USERNM', info.usernm)
      commit('SET_DEPTID', info.deptid)
      commit('SET_LIMITTYPE', info.limittype)// 用户类型
      commit('SET_MOBILETEL', info.mobiletel)// 用户类型
      const roles = []
      let introduction = ''
      if (info.limittype === '9') {
        roles.push('madmin')
        introduction = '我是一个系统管理员'
      } else if (info.limittype === '3'||info.limittype === '4') {
        if(info.limittype === '3'){
          roles.push('ciadmin')
          introduction = '我是一个市管理人员'
        }else{
          roles.push('pradmin')
          introduction = '我是一个省管理人员'
        }
      }else if (info.limittype === '2') {
        roles.push('suadmin')
        introduction = '我是一个勘测队管理人员'
      }else {
        roles.push('aadmin')
        introduction = '我是一个普通用户(APP注册用户)'
      }
      commit('SET_ROLES', roles)
      commit('SET_NAME', info.usernm)
      commit('SET_AVATAR', './static/img/user.jpg')// 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
      commit('SET_INTRODUCTION', introduction)
      info.roles = roles
      
      resolve(info)
    })
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      // logout(state.token).then(() => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resetRouter()

      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
      // }).catch(error => {
      //   reject(error)
      // })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
